import { Col, Row } from 'antd';
import React from 'react';

import PageHeader from '@/components/PageHeader';

import TicketRecordList from './components/TicketRecordList';

const TicketManagement = () => {
  return (
    <Row>
      <Col span={24}>
        <PageHeader
          title="票券紀錄列表"
          breadcrumbs={[
            {
              name: '票券管理',
            },
            {
              name: '票券紀錄列表',
            },
          ]}
        />
        <TicketRecordList />
      </Col>
    </Row>
  );
};

export default TicketManagement;
